module.exports = __webpack_public_path__ + "34bc775d/img/scraper-icon.df6ccde5.svg";